__turbopack_context__.v({
  "container": "Tag-module-scss-module__upZZ6a__container",
  "containerSecondary": "Tag-module-scss-module__upZZ6a__containerSecondary",
  "textPrimary": "Tag-module-scss-module__upZZ6a__textPrimary",
});
